module.exports = __webpack_public_path__ + "static/media/AB_K16_1Z.154ba8c0.jpg";